import React from "react";

export const HomepageContent = ({ text }) => {
  return <div className="mb-10 text-md italic text-gray-700">{text}</div>;
};
